import PageHeader from "../components/PageHeader";
import { PillButton } from "../components/PillButton";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-[70vh] flex items-center">
      <div className="container-x text-center">
        <p className="font-heading font-black text-[26vw] md:text-[16vw] leading-none tracking-tighter text-[#0033A2]">
          404
        </p>
        <h1 className="font-heading font-extrabold text-3xl md:text-4xl tracking-tight -mt-4">
          This page took the elevator elsewhere.
        </h1>
        <p className="mt-4 text-black/60 font-medium max-w-md mx-auto">
          The page you're looking for doesn't exist or has moved.
        </p>
        <div className="mt-8 flex justify-center">
          <PillButton to="/" testid="notfound-home">
            <Home size={18} strokeWidth={2.5} /> Back home
          </PillButton>
        </div>
      </div>
    </div>
  );
}
